import React from "react";
import CandleIncreasePageSection from "../sections/CandleIncreasePageSection/Content";
const CandleIncreasePage = () => {
  return <CandleIncreasePageSection />;
};

export default CandleIncreasePage;
